function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: refactor this to use crystal-ui
import { Modal, Typography, Checkbox, Box, Card, Chip, Button, FormControlLabel, GRAY } from '@applyboard/ui-components';
import { WarningOutlineIcon, WarningFillIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { VerificationResult } from "./types";
import { strings } from "./strings";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function DocumentVerificationModal(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDocumentsMap = _useState2[0],
    setSelectedDocumentsMap = _useState2[1];

  // Use same documents while modal is fading away... otherwise it's jarring to
  // see documents disappear during the modal close animation
  var documents = useValueFromWhenModalWasOpen(props.documents, props.open);

  // eslint-disable-next-line no-restricted-syntax -- TODO: we should try to remove this useEffect
  useEffect(function () {
    if (props.open) {
      setSelectedDocumentsMap({});
    }
  }, [props.open]);
  var warnedDocuments = documents.filter(function (document) {
    return document.documentVerificationResults && document.documentVerificationResults.length > 0;
  });
  var allDocumentWarnings = warnedDocuments.map(getTrackableInfo);
  return _jsxs(Modal, {
    title: _jsxs("div", {
      style: {
        display: 'inline-flex'
      },
      children: [_jsx("div", {
        style: {
          marginRight: '4px',
          marginLeft: '-4px'
        },
        children: _jsx(WarningFillIcon, {
          contrast: "low",
          intent: "warning"
        })
      }), _jsx("div", {
        children: "Warning on Uploaded Document(s)"
      })]
    }),
    open: props.open,
    fullWidth: true,
    maxWidth: "md",
    handleClose: function handleClose() {
      trackEvent({
        event: 'Single Application - Applicant Requirements - Dismissed Flagged Document Modal By Clicking Away OR X',
        data: _objectSpread(_objectSpread({}, props.trackingData), {}, {
          warningReasons: allDocumentWarnings
        })
      });
      props.onClose();
    },
    footerButtons: function footerButtons() {
      return _jsxs(_Fragment, {
        children: [_jsx(Button, {
          onClick: function onClick() {
            trackEvent({
              event: 'Single Application - Applicant Requirements - Clicked Attach All Warned Documents Button On Flagged Document Modal',
              data: _objectSpread(_objectSpread({}, props.trackingData), {}, {
                warningReasons: allDocumentWarnings
              })
            });
            props.onClose();
          },
          style: {
            borderTop: "1px solid ".concat(GRAY[18])
          },
          variant: "text",
          color: "secondary",
          children: "Attach All Warned Documents"
        }), _jsx(Button, {
          onClick: function onClick() {
            var documentIds = Object.keys(selectedDocumentsMap).filter(function (documentId) {
              return selectedDocumentsMap[documentId];
            });
            trackEvent({
              event: 'Single Application - Applicant Requirements - Clicked Delete Selected Document(s) Button On Flagged Document Modal',
              data: _objectSpread(_objectSpread({}, props.trackingData), {}, {
                warningReasons: warnedDocuments.filter(function (document) {
                  return documentIds.includes(document.id);
                }).map(getTrackableInfo),
                percentOfWarnedFilesDeleted: "".concat(documentIds.length / warnedDocuments.length * 100, "%")
              })
            });
            props.onDelete(documentIds);
          },
          loading: props.deleting,
          disabled: props.deleting || Object.keys(selectedDocumentsMap).filter(function (key) {
            return selectedDocumentsMap[key];
          }).length === 0,
          children: "Delete Selected Document(s)"
        })]
      });
    },
    children: [_jsx(Typography, {
      variant: "h6",
      component: "p",
      weight: "semibold",
      children: "The following documents have been flagged for the following reasons. Please consider deleting these documents and trying again to avoid them being rejected later:"
    }), _jsx(Typography, {
      mt: 1,
      children: "(These warnings will apply to all Active Applications with the same requirements)."
    }), _jsx(FormControlLabel, {
      control: _jsx(Checkbox, {
        onChange: function onChange(e, newValue) {
          var newSelectedDocumentsMap = documents.reduce(function (acc, curr) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr.id, newValue));
          }, {});
          setSelectedDocumentsMap(newSelectedDocumentsMap);
        },
        checked: documents.every(function (document) {
          return selectedDocumentsMap[document.id];
        })
      }),
      mt: 2,
      mb: 2,
      label: _jsxs(Typography, {
        variant: "section",
        color: "secondary",
        children: ["SELECT ALL (", documents.length, ")"]
      })
    }), documents.map(function (document, documentIdx) {
      var mentionableWarnings = getMentionableWarnings(document.documentVerificationResults);
      return _jsxs(Box, {
        display: "flex",
        alignItems: "center",
        mt: documentIdx !== 0 ? 2 : 0,
        children: [_jsx(Checkbox, {
          onChange: function onChange(e, newValue) {
            setSelectedDocumentsMap(_objectSpread(_objectSpread({}, selectedDocumentsMap), {}, _defineProperty({}, document.id, newValue)));
          },
          checked: !!selectedDocumentsMap[document.id],
          inputProps: {
            'aria-label': selectedDocumentsMap[document.id] ? "Unselect ".concat(document.fileName, " from being deleted") : "Select ".concat(document.fileName, " to be deleted")
          }
        }), _jsx(Card, {
          ml: 1,
          children: _jsxs(Box, {
            display: "flex",
            alignItems: ['flex-start', 'center'],
            flexDirection: ['column', 'row'],
            children: [_jsx(Box, {
              style: {
                minWidth: '240px'
              },
              mr: 8,
              children: _jsx(Chip, {
                icon: _jsx(WarningOutlineIcon, {}),
                color: "warning",
                children: _jsx("div", {
                  style: {
                    maxWidth: '180px',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                  },
                  children: document.fileName
                })
              })
            }), _jsx(Box, {
              mt: [2, 0],
              children: mentionableWarnings.map(function (result, idx) {
                return _jsxs(Box, {
                  mt: idx !== 0 ? 2 : 0,
                  children: [_jsx(Typography, {
                    mb: 0.5,
                    weight: "semibold",
                    children: strings.warningTitles[result]
                  }), _jsx(Typography, {
                    color: "secondary",
                    children: strings.warningMessages[result]
                  })]
                }, idx);
              })
            })]
          })
        })]
      }, documentIdx);
    })]
  });
}
function getMentionableWarnings(rawResults) {
  var results = [];
  rawResults.forEach(function (result) {
    if (result === VerificationResult.LOW_QUALITY || result === VerificationResult.NAME_NOT_MATCH) {
      results.push(result);
    }
  });
  return results;
}

/**
 * If the modal is closed or closing, this hook returns the last value provided
 * from when the modal was last open.  If the modal is currently open, it
 * returns the same value provided.  This is useful if you want to show stale
 * data while the modal is animating closed.  Sometimes updating to newly fresh
 * data while the modal is closing can be jarring.
 */
function useValueFromWhenModalWasOpen(value, open) {
  var ref = useRef(value);
  if (open) {
    ref.current = value;
  }
  return ref.current;
}
function getTrackableInfo(currentValue) {
  return {
    filename: currentValue.fileName,
    warnings: currentValue.documentVerificationResults
  };
}